import { EpiImage, LoadingStatus } from '@api/types';
import { LoadingSkeleton } from '@components';
import { Box, BoxProps } from '@mui/material';
import { ImageResizerParams, useResponsiveBackground } from '@utils/images.utils';
import classnames from 'classnames';

export type BackgroundImageProps = BoxProps &
  LoadingStatus & {
    image?: EpiImage;
    resizerParams?: ImageResizerParams;
  };

/*
 * Wrap and display CMS image as block element with css background
 */

export const BackgroundImage = ({
  image,
  isLoading,
  className,
  resizerParams = { width: 1200, format: 'webp', quality: 85 } as const,
  ...props
}: BackgroundImageProps) => {
  const imageUrl = typeof image === 'string' ? image : image?.url;
  const backgroundImage = useResponsiveBackground({ imageUrl, resizerParams });
  const mainClassName = classnames('epi-background-image', className);

  if (isLoading) {
    return <LoadingSkeleton className={className} />;
  }

  return <Box {...props} sx={backgroundImage} className={mainClassName} />;
};
